import React, {Component} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import Loading from "../../Loading";
import MomentLocaleUtils, {formatDate, parseDate} from "react-day-picker/moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import {connect} from "react-redux";

class VcbSalePerformanceUploadCreate extends Component{
    constructor(props) {
        super(props);
        const INITIAL_ITEM = {
            id:'',
            reportCode:'',
            reportName:'',
            reportType:'',
            reportDate:null,
            status:'',
            bank:'',
            createdBy:props?.username,
            createdDate:'',
            updatedDate:'',
        }
        this.state = {
            isLoading: false,
            successMessage: '',
            errorMessage: '',
            item:INITIAL_ITEM,
            isReportDateEmpty: true,
            isReportDateValid: false,
            isReportDateDisabled: false,
            selectedFile: null,
            isSelectedFile: false,
            createdBy: props?.username
        }
        this.onFileChange = this.onFileChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBankCodeChange = this.handleBankCodeChange.bind(this);
        this.handleReportCodeChange = this.handleReportCodeChange.bind(this);
        this.handleReportTypeChange = this.handleReportTypeChange.bind(this);
        this.handleReportDateChange = this.handleReportDateChange.bind(this);
        this.handleDownloadTemplateReportBoto = this.handleDownloadTemplateReportBoto.bind(this);
        this.handleDownloadTemplateReportBanker  = this.handleDownloadTemplateReportBanker.bind(this);
    }
    componentDidMount() {
        const { item } = this.state;
        item.bank = 'VCB';
        item.reportCode = 'BOTO_PERFORMANCE';
        item.reportName = 'Báo cáo BOTO Performance';
        item.reportType = 'DETAIL';
        let currentDate = new Date();
        item.reportDate = formatDate(currentDate, 'DD/MM/YYYY');
        this.setState({
            selectedDay: currentDate,
            isReportDateEmpty: false,
            isReportDateValid: true,
        });
        this.setState({item});
    }

    onFileChange(e) {
        // Update the state
        this.setState({ selectedFile: e.target.files[0], isSelectedFile: true });
    };

    handleSubmit(){
        const {item, selectedFile, isSelectedFile,isReportDateEmpty,isReportDateValid} = this.state
        let isValidForm = false;

        if(isReportDateEmpty){
            this.setState({errorMessage:'Ngày báo cáo không được rỗng'});
            return;
        }
        if(!isReportDateValid){
            this.setState({errorMessage:'Ngày báo cáo không hợp lệ'});
            return;
        }

       // const reportDateNumber = item?.reportDate.split('/')[2]+item?.reportDate.split('/')[1]+item?.reportDate.split('/')[0];
        if(!isSelectedFile){
            this.setState({errorMessage:'Vui lòng chọn file báo cáo để upload'});
            return;
        }
        if(isSelectedFile){
            const fileName = selectedFile?.name;
            const fileExtension = fileName.substring(fileName.lastIndexOf('.')+1, fileName.length) || fileName;
            if(fileExtension.toUpperCase() !== 'XLSX'){
                this.setState({errorMessage:'Vui lòng chọn tập tin XLSX khi upload báo cáo'});
                return;
            }
        }

        isValidForm = true;
        if(isValidForm === true){
            this.setState({errorMessage:''});
            const formData = new FormData();

            formData.append("bank", item?.bank);
            formData.append("reportDate", item?.reportDate);
            formData.append("reportCode", item?.reportCode);
            formData.append("reportName", item?.reportName);
            formData.append("reportType", item?.reportType);
            formData.append("createdBy", item?.createdBy);
            formData.append("file", selectedFile);
            this.setState({isLoading: true});
            axios.post('/api/bankportal/report/vcb/salePerformance/upload/save', formData)
                .then(res =>{
                    if(res.data !== null){
                        console.log('Upload success:'+res);
                        this.setState({successMessage: 'Upload thành công',errorMessage:'', isLoading: false});
                    }else{
                        this.setState({successMessage: '',errorMessage:'Upload File thất bại', isLoading: false});
                    }

                })
                .catch(error => {
                    console.log(error?.response);
                    this.setState({errorMessage: error?.message,successMessage:'', isLoading: false})
                })
        }else{
            this.setState({errorMessage: 'Vui lòng kiểm tra lại thông tin !',successMessage:'', isLoading: false})
        }
    }

    handleReportDateChange(selectedDay, modifiers, dayPickerInput) {
        const input = dayPickerInput.getInput();
        const {item} = this.state;
        item.reportDate = formatDate(selectedDay, 'DD/MM/YYYY');
        this.setState({
            item: item,
            isReportDateEmpty: !input.value.trim(),
            isReportDateValid: typeof selectedDay !== 'undefined',
            isReportDateDisabled: modifiers.disabled === true
        });
    }

    handleBankCodeChange = (e) => {
        const { item } = this.state;
        item.bank = e.target.value;
        this.setState({item});
    }

    handleReportCodeChange = (e) => {
        const { item } = this.state;
        item.reportCode = e.target.value;
        if (item.reportCode === 'BOTO_PERFORMANCE'){
           item.reportName = 'Báo cáo BOTO Performance';
        }
        if (item.reportCode === 'BANKER_PERFORMANCE'){
            item.reportName = 'Báo cáo BANKER Performance';
        }
        this.setState({item});
    }

    handleReportTypeChange = (e) => {
        const { item } = this.state;
        item.reportType = e.target.value;
        this.setState({item});
    }

    handleDownloadTemplateReportBoto() {
        axios.get('/api/bankportal/report/vcb/boto/salePerformance/template/download', {
            responseType: 'arraybuffer',
        }).then(response => {
            console.log(response);
            console.log(response.data);
            if(!!response.data){
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'Template_Report_BOTO_Performance_Detail.xlsx';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }else{
                console.log('Error when download file');
            }
        });
    }

    handleDownloadTemplateReportBanker(){
        axios.get('/api/bankportal/report/vcb/banker/salePerformance/template/download', {
            responseType: 'arraybuffer',
        }).then(response => {
            if(!!response.data){
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'Template_Report_Banker_Performance_Detail.xlsx';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }else{
                console.log('Error when download file');
            }
        });
    }

    render() {
        const {item, isLoading,errorMessage, successMessage} = this.state;
        if(isLoading === true) return <Loading />;
        return (
            <div className={'container'}>
                <div>
                    <div>
                        { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                        { !!successMessage && <div className={"alert alert-info"} role="alert">{ successMessage }</div> }
                        <h2 className="m-3 text-primary">TẠO MỚI SALE PERFORMANCE - UPLOAD</h2>
                        <form>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="name">Ngân hàng :</label>
                                <div className="col-sm-9">
                                    <select id="bank" className="form-control" value={item?.bank}
                                            onChange={this.handleBankCodeChange}>
                                        <option value="VCB">Vietcombank</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="reportCode">Tên báo cáo :</label>
                                <div className="col-sm-9">
                                    <select id="reportCode" className="form-control" value={item?.reportCode}
                                            onChange={this.handleReportCodeChange}>
                                        <option value="BOTO_PERFORMANCE">Báo cáo BOTO Performance</option>
                                        <option value="BANKER_PERFORMANCE">Báo cáo BANKER Performance</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="name">Loại báo cáo :</label>
                                <div className="col-sm-9">
                                    <select id="reportType" className="form-control" value={item?.reportType}
                                            onChange={this.handleReportTypeChange}>
                                        <option value="DETAIL">DETAIL</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="reportDate">Ngày báo cáo :</label>
                                <div className="col-sm-9">
                                    <DayPickerInput
                                        value={item.reportDate}
                                        onDayChange={this.handleReportDateChange}
                                        selectedDay={item.reportDate}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        format="DD/MM/YYYY"
                                        placeholder='DD/MM/YYYY'
                                        dayPickerProps={{
                                            selectedDays: item.reportDate,
                                            locale: 'vi-VN',
                                            localeUtils: MomentLocaleUtils,
                                        }}
                                        inputProps={{className: 'form-control'}}/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="control-label col-sm-3">Chọn File báo cáo để tải lên:</label>
                                <div className="col-sm-9">
                                    <input type="file" className={'form-control-file'} onChange={this.onFileChange}/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3">Tải file mẫu:</label>
                                <div className="col-sm-9">
                                    <button type="button" onClick={this.handleDownloadTemplateReportBoto}
                                            className="btn btn-link ml-1">Báo cáo BOTO
                                    </button>
                                    |
                                    <button type="button" onClick={this.handleDownloadTemplateReportBanker}
                                            className="btn btn-link ml-1">Báo cáo BANKER
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Link to={'/bp/salePerformance/upload/list'} className="btn btn-success">Quay
                                        về</Link>
                                    <button type="button" onClick={this.handleSubmit}
                                            className="btn btn-primary ml-1">Upload báo cáo
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const authorities = state?.auth?.authorities;
    const isRoleHO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_HO');
    const isRoleFWDContest = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_CONTEST');
    const isRoleBO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BO');
    const isRoleTO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_TO');
    const username = state?.auth?.name;
    return {username, isRoleHO, isRoleFWDContest, isRoleBO, isRoleTO};
};

export default connect(mapStateToProps)(VcbSalePerformanceUploadCreate);
